import { serviceRoutes, get } from "./index";

export async function consultarCiudades() {
  return await get(serviceRoutes.consultarCiudades, "");
}
